import * as THREE from 'three'
import type { MarkerType } from 'Common/types/elements/visualizer/marker'
import type { Mesh, MeshStandardMaterial, SphereGeometry } from 'three'
import type { InteractionManager } from 'three.interactive'
import type { MarkerEventCallback } from 'Common/types/elements/visualizer/visualizerTypes'

interface MarkerModel {
    marker: MarkerType
    eventCallback: MarkerEventCallback
    interactionManager: InteractionManager
    mesh: Mesh<SphereGeometry, MeshStandardMaterial> | null
    defaultMaterial: MeshStandardMaterial
}

class MarkerModel implements MarkerModel {
    constructor(marker, eventCallback?, interactionManager?, mesh?) {
        this.marker = marker
        this.eventCallback = eventCallback
        this.interactionManager = interactionManager
        this.mesh = mesh || this.createMarkerMesh()
    }

    /**
     * Creates Marker mesh and sets default properties for the mesh
     */
    createMarkerMesh(): Mesh<SphereGeometry, MeshStandardMaterial> | null {
        if (!this.marker) {
            console.error('No marker information was provided.')
            return
        }

        const markerGeometry = new THREE.SphereGeometry(0.2, 12, 8)
        const markerMesh = new THREE.Mesh(markerGeometry, this.defaultMaterial)
        const markerPosition = new THREE.Vector3(this.marker.locx, this.marker.locy, this.marker.locz)

        markerMesh.position.set(markerPosition.x, markerPosition.y, markerPosition.z)

        markerMesh.name = this.marker.name
        return markerMesh
    }
}

export { MarkerModel }
